module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-video-signaling-2019-12-04.paginators.json
// module id = 1362
// module chunks = 0